import "../assets/styles/views/home.scss";
import Clock from "../assets/icons/clock";
import Study from "../assets/icons/study";
import Search from "../assets/icons/search";
import { useEffect, useState } from "react";
import { useOutletContext } from "react-router-dom";
import { container, container_by_pv } from "../utils/endpoints";
import ContainerCard from "../components/ContainerCard";
import PillCard from "../components/PillCard";
import CloseRounded from "../assets/icons/close-rounded";
import { getCookie } from "../utils/cookie";

export default function Home() {
  const [context, setContext] = useOutletContext();
  const [pills_container_list, setPillsContainerList] = useState();
  const [pills_container_list_filter, setPillsContainerListFilter] = useState();
  const [current_search, setCurrentSearch] = useState("");
  const [completed_count, setCompletedCount] = useState(0);
  const [total_count, setTotalCount] = useState(0);
  const [time_count, setTimeCount] = useState(0);

  useEffect(() => {
    if (pills_container_list && context.progress) {
      let total = 0;
      let completed = 0;
      let time = 0;

      pills_container_list.map((item, index) => {
        let temp_total = 0;

        item.learningPills.map((sub_item, sub_index) => {
          if (sub_item.assetIdentifier) {
            temp_total++;
            let pill_completed_info = context.progress.find(
              (x) =>
                x.cmId.toString() === sub_item.assetIdentifier && x.state > 0
            );
            if (pill_completed_info) {
              completed++;
              time += sub_item.duration || 0;
            }
          }
        });

        total += temp_total;
      });

      setTotalCount(total);
      setCompletedCount(completed);
      setTimeCount(time >= 60 ? Math.floor(time / 60) : 0);
    }
  }, [pills_container_list, context.progress]);

  useEffect(() => {
    const impersonate_pv = getCookie("pv_impersonate");
    if (!!context.session && pills_container_list == null) {
      (async () => {
        setContext({ loader: true });
        let response = await context.httpRequest(
          "get",
          impersonate_pv
            ? container_by_pv.replace("*", impersonate_pv)
            : container,
          null,
          context.session.token
        );

        if (response.result) {
          let sorted_response = response?.data.sort(function (a, b) {
            return a.playlistIndex - b.playlistIndex;
          });
          setPillsContainerList(sorted_response);
          setPillsContainerListFilter(sorted_response);
          context.updateUserProgress(context);
        }
        setContext({ loader: false });
      })();
    }
  }, [context.session]);

  useEffect(() => {
    let info_message = document.querySelector(".home__info-message");
    if (!!current_search) {
      if (info_message && context.device == "mb")
        info_message.style.display = "none";
      let list = pills_container_list.filter((x) => {
        let result = x.learningPills.filter((y) =>
          y.title.toUpperCase().includes(current_search.toUpperCase())
        );
        if (result.length > 0) {
          x["filteredLearningPills"] = result;
          return x;
        }
      });

      setPillsContainerListFilter(list);
    } else {
      setPillsContainerListFilter(pills_container_list);
      if (info_message) info_message.style.display = "block";
    }
  }, [current_search]);

  return (
    <>
      <section className="w-100 d-flex home px-md-3">
        <div className="home__info-message position-sticky p-3 p-md-0 mt-4 my-md-3 mx-3 mx-md-0 shadow-sm">
          <h3 className="mt-1 mb-2">Le tue attività:</h3>
          <div className="d-flex flex-column flex-md-row mb-md-4">
            <div className="d-flex align-items-center">
              <Clock
                className="me-md-2"
                size={context.device === "mb" ? 24 : 34}
                color="#20419a"
              />
              <span className="ms-3 ms-md-2 fw-bold">
                {`Hai fruito ${time_count} minut${
                  time_count === 1 ? "o" : "i"
                } di formazione`}
              </span>
            </div>
            <div className="d-flex align-items-center mt-2 mt-md-0 ms-md-4">
              <Study
                className="me-md-2"
                size={context.device === "mb" ? 24 : 34}
                color="#20419a"
              />
              <span className="ms-3 ms-md-2 fw-bold">
                Hai completato {completed_count}/{total_count} pillole
              </span>
            </div>
          </div>
        </div>

        <div
          id="search-on-page"
          className="home__search ms-md-auto position-sticky d-flex align-items-center px-3 px-md-0 py-3 py-md-0 my-md-4 "
        >
          <input
            type="text"
            placeholder="Cerca"
            value={current_search}
            className="w-100 shadows mt-0 ms-md-auto ps-3 pe-5 py-2"
            onChange={(e) => setCurrentSearch(e.target.value)}
          />
          {!!current_search ? (
            <CloseRounded
              color="#2d2d2d"
              size={20}
              className="position-absolute"
              onClick={() => setCurrentSearch("")}
            />
          ) : (
            <Search color="#cccccc" size={22} className="position-absolute" />
          )}
        </div>

        {!!current_search &&
        pills_container_list_filter.length > 0 &&
        context.device !== "mb" ? (
          <strong className="search-title d-block mx-auto mt-2 mb-4">
            Risultati della ricerca:
          </strong>
        ) : null}

        <div
          className={`home__container-list mb-md-5 d-md-flex flex-md-wrap main-panel w-100 p-3 p-md-0 ${
            !!current_search && pills_container_list_filter.length > 0
              ? "search-list-container"
              : ""
          }`}
        >
          {!!current_search &&
          pills_container_list_filter.length > 0 &&
          context.device === "mb" ? (
            <strong className="mb-3 d-block w-100">
              Risultati della ricerca:
            </strong>
          ) : null}

          {!!pills_container_list_filter &&
          pills_container_list_filter.length > 0 ? (
            pills_container_list_filter.map((item, index) => {
              return !!current_search ? (
                <div
                  key={index}
                  className="sub-search-panel px-md-0 pt-3 overflow-hidden mb-3 mx-md-auto shadow-sm border"
                >
                  <strong className="border-bottom px-3 px-md-3 d-block pb-2">
                    {item.title}
                  </strong>
                  {!!item.filteredLearningPills
                    ? item.filteredLearningPills.map((sub_item, index) => {
                        return (
                          <PillCard
                            key={index}
                            pill_info={sub_item}
                            container_info={item}
                            context={context}
                            setContext={setContext}
                          />
                        );
                      })
                    : null}
                </div>
              ) : (
                <ContainerCard
                  key={index}
                  container_info={item}
                  context={context}
                />
              );
            })
          ) : !!pills_container_list_filter &&
            pills_container_list_filter.length === 0 ? (
            <span className="nothing-found-message d-block w-100 text-center mt-5">
              Nessun risultato da mostrare
            </span>
          ) : null}
        </div>
      </section>
    </>
  );
}
